<div class="container">
    <input #slider type="range" min="0" [max]="intervalCount" step="1" [value]="sliderValue" (input)="updateSliderValue(slider.value)" [disabled]="disabled" />
    <input #textbox type="text" [value]="valueString" (change)="updateValue(textbox.value)" [size]="numDps + 2" [disabled]="disabled" />
</div>
